import React from 'react'

function Breadcrumb() {
  return (
    <div className="breadcrumb-full-width">
      <div className="container-fixed">
        <ul className="breadcrumb">
          <li className="breadcrumb__item">
            <a href="/">CGTrader</a>
          </li>
          <li className="breadcrumb__item">
            <a href="/profile">Profile</a>
          </li>
          <li className="breadcrumb__item is-active">My Sales</li>
        </ul>
      </div>
    </div>
  )
}

export default Breadcrumb
